import React, { useEffect, useState } from 'react';
import { ButtonBase, Typography } from '@mui/material';
import { WebMercatorViewport } from '@deck.gl/core';
import { useDebouncedCallback } from 'use-debounce';

import './PanoramaToggleButton.sass';

const PanoramaToggleButton = ({
  views,
  mapboxMapRef,
  onChange,
  viewState,
  dataEditor
}) => {
  const [currentView, setCurrentView] = useState('map');
  const [satelliteImageSrc, setSatelliteImageSrc] = useState(null);
  const [location, setLocation] = useState(null);
  const [image, setImage] = useState(null);

  const MAPBOX_ACCESS_TOKEN =
    'pk.eyJ1IjoiZ3JpZG1hcmtldCIsImEiOiJjbDkydWs3MzEweXEzM250Z3dzcmQ5ajRtIn0.HJU00OC2YDjxV2KAUJiVyg';

  const debounced = useDebouncedCallback(() => {
    if (!mapboxMapRef || !viewState) return;

    const { latitude, longitude, zoom } = viewState;
    const location = `${latitude},${longitude}`;
    const url = `https://api.mapbox.com/styles/v1/mapbox/satellite-v9/static/${longitude},${latitude},${
      zoom > 18 ? 18 : zoom
    },0/300x200?access_token=${MAPBOX_ACCESS_TOKEN}`;
    setSatelliteImageSrc(url);
    setLocation(location);

    if (dataEditor) {
      setCurrentView('satellite');
    }
    if (typeof mapboxMapRef.getCanvas !== 'undefined') {
      const dataUrl = mapboxMapRef.getCanvas().toDataURL();
      setImage(dataUrl);
    } else {
      if (!mapboxMapRef?.current) return;

      const viewport = new WebMercatorViewport(viewState);
      const nw = viewport.unproject([0, 0]);
      const se = viewport.unproject([viewport.width, viewport.height]);
      const bbox = `${nw[0]},${se[1]},${se[0]},${nw[1]}`;
      const dataUrl = `https://api.mapbox.com/styles/v1/mapbox/light-v10/static/[${bbox}]/200x130?access_token=pk.eyJ1Ijoia3JpejkiLCJhIjoiY2lna3hzcjc3MDA4ZHZpa3RicmFocTY3diJ9.QpU33nYdvz01BECV2bCrvA&attribution=false&logo=false`;

      setImage(dataUrl);
    }
  }, 1200);

  useEffect(() => {
    debounced();
  }, [mapboxMapRef, viewState]);

  const setNextView = event => {
    event.preventDefault();
    event.stopPropagation();
    const currentIndex = views.indexOf(currentView);
    const nextIndex = (currentIndex + 1) % views.length;
    const nextView = views[nextIndex];
    setCurrentView(nextView);
    onChange(nextView);
  };
  const className = `header-map-toggle header-map-toggle-${currentView}`;
  if (!location) return null;
  return (
    <div className={className}>
      <ButtonBase onClick={setNextView}>
        {currentView === 'satellite' && (
          <Typography variant="body1">Switch to map view</Typography>
        )}

        {currentView === 'map' && views.length === 3 && (
          <Typography variant="body1">Switch to street view</Typography>
        )}

        {currentView === 'map' && views.length === 2 && (
          <Typography variant="body1">Switch to satellite view</Typography>
        )}

        {currentView === 'panorama' && (
          <Typography variant="body1">Switch to satellite view</Typography>
        )}

        <div className="street-view-toggle-image">
          {currentView === 'map' && (
            <img
              className="street-view-toggle-image-panorama"
              zIndex="-1"
              width="200"
              height="130"
              src={`https://maps.googleapis.com/maps/api/streetview?size=300x300&location=${encodeURI(
                location
              )}&key=AIzaSyAqNSqJg9tICtIVa01g1fBj-yI-naGifyA&fov=90&radius=50&source=outdoor&pitch=20`}
              alt=""
            />
          )}

          {currentView === 'satellite' && (
            <img
              className="street-view-toggle-image-satellite"
              width="200"
              height="130"
              src={image}
              alt=""
            />
          )}

          {(currentView === 'panorama' ||
            (currentView === 'map' && views.length === 2)) && (
            <img
              className="street-view-toggle-image-satellite"
              width="200"
              height="130"
              src={satelliteImageSrc}
              alt=""
            />
          )}
        </div>
      </ButtonBase>
    </div>
  );
};

export default PanoramaToggleButton;
